import * as React from 'react';
import { Table } from 'semantic-ui-react';
import { salas } from '../salas';

const Salas: React.FunctionComponent = () => {
    return (
        <Table collapsing compact striped columns='2'>
            <Table.Header>
                <Table.Row textAlign='center'>
                    <Table.HeaderCell content='Sala' />
                    <Table.HeaderCell content='Capacidad' />
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {salas.map(sala => (
                    <Table.Row key={sala.nombre} textAlign='center'>
                        <Table.Cell content={sala.nombre} />
                        <Table.Cell content={sala.capacidad} />
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );
};

export default Salas;



// WEBPACK FOOTER //
// ./src/modulos/Horarios/componentes/Salas.tsx